export const AUTOCOMPLETE_TITLE = Symbol('autocompleteTitle')
